<template>
  <SfeTooltip
    :showContent="!!content"
    :fitContent="fitContent"
    :position="position"
    :interactive="isInteractive"
  >
    <template #trigger>
      <div :class="triggerClass">
       <slot></slot>
      </div>
    </template>
    <template #content>
      <!-- v-html is used for the content prop here, cause the content may contain and not escape HTML tags like <br> for line breaks so the tooltip doesn't spread across the screen in some use cases. -->
        <div :class="hasAction ? 'mx-2' : ''" v-html="content"></div> 
        <div v-if="hasAction && isInteractive">
          <!-- A slot is passed here so it can be used for anything, depending on the use case. This makes it to be very flexible for usage. You could pass a button, checkbox, or any other thing depending on your use case. Just remeber to pass the isInteractive prop and you'll be able to access it, where you need it. -->
          <slot name="action"></slot>
        </div>
    </template>
  </SfeTooltip>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'top'
    },
    triggerClass: {
      type: String,
      default: ''
    },
    fitContent: {
      type: Boolean,
      default: false
    },
    isInteractive: {
      type: Boolean,
      default: false,
      description: 'This is used to communicate with the interactive prop in the SfeToolTip itself. It allows the tooltip to be interractive.'
    },
    hasAction: {
      type: Boolean,
      default: false,
      description: 'This prop allows us to be able to make the tooltip to be interractive in such a way that more actions can be taken in the tooltip. This only works when the isInteractive prop is passed as well.'
    }
  }
}
</script>
